import { useGridSettingsStatusMap, useOptionalActivePageId, usePageProducts } from "../../../data";
import { colParams } from "../../utils";
import { useUpdateColumnFromCellByValueAndOperation } from "../../market-grid/keyboard/useUpdateColumnFromCellByValueAndOperation";
import { useGrid } from "../../market-grid/stores";
import { captureEvent } from "../../../utils/o11y";

export function useReconfirmDataLogic() {
  const pageProducts = usePageProducts(useOptionalActivePageId()).data;
  const statusMap = useGridSettingsStatusMap();
  const [gridApi] = useGrid();
  const updateColumnFromCellByValueAndOperation = useUpdateColumnFromCellByValueAndOperation();

  const hasDataToReconfirm = Object.entries(statusMap).some(
    ([productId, status]) =>
      (status === "broadcast" || status === "hybrid_broadcast") &&
      pageProducts?.some((prod) => prod.product_id === productId),
  );

  const handleConfirm = () => {
    captureEvent("clicked_reconfirm_page");
    gridApi?.getColumns()?.map((col) => {
      const params = colParams(col);
      const status = statusMap[params?.productId || ""];
      if (["broadcast", "hybrid_broadcast"].includes(status)) {
        updateColumnFromCellByValueAndOperation({
          operation: "=",
          api: gridApi,
          column: col,
          startIndex: 0,
        });
      }
    });
  };

  return {
    hasDataToReconfirm,
    handleConfirm,
  };
}
